import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0733d6d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sidebar"
};
import MenuItem from "./MenuItem.vue";
import Title from "./title.vue";
import { useStore } from "@/store/index";
import { useRoute } from "vue-router";
import { computed } from "vue";
export default {
  __name: 'sidebar',
  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const activeMenu = computed(() => {
      const {
        meta,
        path
      } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Title), _createVNode(_component_el_scrollbar, {
        "wrap-class": "scrollbar-wrapper"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          class: "el-menu-vertical-demo",
          "unique-opened": true,
          "background-color": "#304156",
          "text-color": "#fff",
          "active-text-color": "#409EFF",
          "collapse-transition": false,
          mode: "vertical"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).routers, menuItem => {
            return _openBlock(), _createBlock(MenuItem, {
              key: menuItem.path,
              item: menuItem,
              "base-path": menuItem.path
            }, null, 8, ["item", "base-path"]);
          }), 128))]),
          _: 1
        }, 8, ["default-active"])]),
        _: 1
      })]);
    };
  }
};